module.exports = __webpack_public_path__ + "userCenter-achievement-icon2-20e37700.png";